import React from "react";
import "./StatCard.css";
import {
  LockShieldIcon,
  NotificationBellIcon,
  CameraIcon,
  CashIcon,
  UsersGroupIcon,
} from "../../helper/icon";

const StatCard = ({
  title,
  value,
  subtitle,
  icon,
  iconColor = "#003B0D",
  isGreen = false,
  filters = null,
  showCard = true,
}) => {
  if (!showCard) return null;

  return (
    <div className={`stat-card ${isGreen ? "green" : ""}`}>
      <div className="stat-header">
        <div className="stat-title">{title}</div>
        <div className={`icon-container ${isGreen ? "green-icon" : ""}`}>
          {icon}
        </div>
      </div>
      <div className="stat-value">{value}</div>
      {subtitle && <div className="stat-subtitle">{subtitle}</div>}
      {filters && (
        <div className="stat-filters">
          {filters.map((filter, index) => (
            <button
              key={index}
              className={`filter-button ${filter.active ? "active" : ""}`}
            >
              {filter.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const StatCards = ({ stats, displayCards = {} }) => {
  const {
    totalGuest = true,
    eventAttire = true,
    ticketAmount = true,
    cashGift = true,
    refundRequest = true,
    totalEvent = true,
    overallAmount = true,
  } = displayCards;

  // console.log("Stats received in StatCards:", stats);


  const overallAmountValue =
    typeof stats?.overallAmount === "number" && stats.overallAmount >= 0
      ? stats.overallAmount.toLocaleString("en-NG", {
          style: "currency",
          currency: "NGN",
        })
      : "₦0.00";

  const eventAttireAmount =
    typeof stats?.eventAttireAmount === "number" && stats.eventAttireAmount >= 0
      ? stats.eventAttireAmount.toLocaleString("en-NG", {
          style: "currency",
          currency: "NGN",
        })
      : "₦0.00";

  const totalTicketAmount =
    typeof stats?.ticketAmount === "number" && stats.ticketAmount >= 0
      ? stats.ticketAmount.toLocaleString("en-NG", {
          style: "currency",
          currency: "NGN",
        })
      : "₦0.00";

  const cashGiftAmount =
    typeof stats?.cashGiftAmount === "number" && stats.cashGiftAmount >= 0
      ? stats.cashGiftAmount.toLocaleString("en-NG", {
          style: "currency",
          currency: "NGN",
        })
      : "₦0.00";

  const totalGuests =
    typeof stats?.totalGuests === "number" ? stats.totalGuests : 0;

  const refundRequests =
    typeof stats?.refundRequests === "number" ? stats.refundRequests : 0;

  const totalEvents =
    typeof stats?.totalEvents === "number" ? stats.totalEvents : 0;

  const guestFilters = [
    { label: "Regular", active: true },
    { label: "RSVP", active: false },
    { label: "All", active: false },
  ];

  const monthFilters = [
    { id: "all", label: "All", active: true },
    { id: "lastMonth", label: "Last Month", active: false },
    { id: "thisMonth", label: "This Month", active: false },
  ];

  return (
    <div className="dashboard-container">
      <StatCard
        showCard={overallAmount}
        title="Overall Amount"
        value={overallAmountValue}
        icon={<LockShieldIcon />}
        isGreen={true}
        filters={monthFilters}
      />
      <StatCard
        showCard={totalEvent}
        title="Total Event"
        value={totalEvents}
        subtitle="Total number of event created"
        icon={<NotificationBellIcon />}
        isGreen={true}
      />
      <StatCard
        showCard={eventAttire}
        title="Event Attire Amount"
        value={eventAttireAmount}
        subtitle="Total amount on event attire"
        icon={<CameraIcon />}
      />
      <StatCard
        showCard={ticketAmount}
        title="Ticket Amount"
        value={totalTicketAmount}
        subtitle="Total amount on ticket purchase"
        icon={<CameraIcon />}
      />
      <StatCard
        showCard={cashGift}
        title="Total Cash Gift"
        value={cashGiftAmount}
        subtitle="Total amount of cash gift"
        icon={<CashIcon />}
      />
      <StatCard
        showCard={totalGuest}
        title="Total Guest"
        value={totalGuests}
        icon={<UsersGroupIcon />}
        filters={guestFilters}
      />
      <StatCard
        showCard={refundRequest}
        title="Refund Request"
        value={refundRequests}
        subtitle="Total number of refund requests"
        icon={<CameraIcon />}
      />
    </div>
  );
};

export default StatCards;
